exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/cash-book/cash-book-list/cash-book-list.component.css
// module id = ../../../../../src/app/component/cash-book/cash-book-list/cash-book-list.component.css
// module chunks = main